<template>
  <main class="l-main p-register set">
    <div class="l-block">
      <div class="p-register-nav">
        <Button :to="backTo" variant="light" icon="pageback" radius>
          {{ projectId ? 'サイト設定に戻る' : 'サイト一覧に戻る' }}
        </Button>
        <Button variant="light" class="logout" radius @click="logout">
          ログアウト
        </Button>
      </div>
      <TitleRegister />
      <div class="l-block__content">
        <div class="hTitle">
          <h1>Google Analytics認証エラー</h1>
        </div>
        <Loading v-if="isLoading" transparent />
        <template v-else>
          <div class="message">
            <Alert>アカウントの再認証を行ってください</Alert>
          </div>
          <div class="btnArea">
            <div class="form-auto">
              <Button
                :to="backTo"
                variant="border"
                size="w260"
                fsize="f16"
                icon="return_gn"
              >
                戻る
              </Button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Loading from '@/components/Loading';
import TitleRegister from '@/components/TitleRegister';

export default {
  components: {
    Alert,
    Button,
    Loading,
    TitleRegister
  },
  data() {
    return {
      projectId: '',
      isLoading: true
    };
  },
  computed: {
    backTo() {
      if (this.projectId) {
        return {
          name: 'configProject',
          params: { projectId: this.projectId }
        };
      } else {
        return {
          name: 'projects'
        };
      }
    },
    tmpKey() {
      return this.$store.state.set.ga4.params.tmpKey;
    }
  },
  created() {
    if (!this.tmpKey) {
      this.$router.push({ name: 'projects' });
      return;
    }
    this.auth
      .getUserData()
      .then(response => {
        const projects = response.data.user_metadata.projects;
        for (let i = 0; i < projects.length; i++) {
          if (projects[i].tmpKey === this.tmpKey) {
            this.projectId = String(projects[i].projectId);
            break;
          }
        }
        this.isLoading = false;
      })
      .catch(error => {
        this.isLoading = false;
      });
  },
  methods: {
    logout() {
      this.auth.logout();
    }
  }
};
</script>
